<template>
    <div class="full-width full-height dynamic-form q-pa-md">
        <div class="row q-pa-md q-py-sm q-col-gutter-x-lg q-col-gutter-y-xs">
          <jt-dynamic-form
            v-if="formModel"
            ref="jtDynamicForm"
            :inputs="formModel.inputs"
            :interface="formModel.nmInterface"
            :relacionamentos="formModel.relacionamentos"
            :model="addressPersonBilling"
            no-scroll
            form-class="jtDFModalReasonJustificationWaste"
          />
        </div>
        <div class="row full-width q-col-gutter-lg justify-center q-py-lg" v-if="forms[0] && forms[0].buttons.length > 0">
            <div v-for="(button, i) in forms[0].buttons" :key="i" class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="info" @click="actionButton(button)">
                <q-icon
                    v-if="button.icon"
                    :name="button.icon"
                    size="18px"
                    class="position-icon-filter"
                />
                {{ button.label }}
                </q-btn>
            </div>
        </div>
        <q-dialog v-if="flModal" v-model="flModal">
          <q-layout class="replicate-modal bg-white">
            <q-header class="bg-primary">
              <q-toolbar>
                <q-toolbar-title>{{
                  $gettext("REPLICATE_DATA")
                }}</q-toolbar-title>
                <q-btn
                  v-close-popup
                  flat
                  round
                  dense
                  size="1.5em"
                  icon="cancel"
                />
              </q-toolbar>
            </q-header>
            <q-page-container class="card-container-modal">
              <div class="replicate-modal-content">
                <span class="replicate-modal-message">Você deseja replicar os dados de cliente?</span>
                <div class="replicate-modal-buttons">
                  <button tabindex="0" @click="replicateData()" type="button" class="q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle bg-secondary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active">
                    <span class="q-focus-helper"></span>
                      <span class="q-btn__wrapper col row q-anchor--skip">
                        <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
                          Replicar
                        </span>
                    </span>
                  </button>
                </div>
              </div>
            </q-page-container>
          </q-layout>
        </q-dialog>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtTextInput } from 'jtech-webcomps'
import { remove } from 'mobx'
import ClientChargeForm from './client-model/client-charge.form'

@Component({
  components: {
    JtTextInput
  },
  props: {
    forms: {},
    title: String,
    addressPersonBillingState: {},
    client: {}
  }
})
class ClientRegisterCharge extends Vue {
    formModel = {};
    flModal = false;
    addressPersonBilling = new ClientChargeForm();

    mounted () {
      this.addressPersonBilling = this.addressPersonBillingState
      this.forms[0].inputs = this.forms[0].inputs.filter(
        (i) => i.type != 'COMPOSICAO'
      )
      this.formModel = this.forms[0]
      if (!this.addressPersonBilling.addressName) {
        this.flModal = true
      }
    }

    replicateData () {
      this.addressPersonBilling.addressName = this.client.addressName
      this.addressPersonBilling.number = this.client.number
      this.addressPersonBilling.detail = this.client.detail
      this.addressPersonBilling.neighborhood = this.client.neighborhood
      this.addressPersonBilling.zipCode = this.client.zipCode
      this.addressPersonBilling.city = this.client.cityText
      this.addressPersonBilling.state = this.client.stateText
      this.flModal = false
    }

    get elInputs () {
      return [...this.inputs, ...this.phones, ...this.emails]
    }

    get inputs () {
      this.forms[0].inputs = this.forms[0].inputs.filter(
        (i) => i.type != 'COMPOSICAO'
      )
      return this.forms[0].inputs
    }

    get emails () {
      return this.formModel?.dadosForm?.contactPersonEmails?.map(email => ({
        value: email,
        label: this.$gettext('EMAIL'),
        columnsSize: 3
      })) || []
    }

    get phones () {
      if (!this.formModel?.dadosForm?.contactPersonPhones) {
        return []
      }

      return this.formModel?.dadosForm?.contactPersonPhones.map(phone => ({
        value: phone,
        label: this.$gettext('PHONE'),
        columnsSize: 3
      }))
    }

    async actionButton (button, params, page) {
      if (!this.$refs.jtDynamicForm.isValidForm()) {
        return
      }
      this.$emit('action-button', button, params, page)
      this.$emit('save-charge', this.addressPersonBilling)
    }
}
export default ClientRegisterCharge
</script>
<style lang="stylus" scoped>
.replicate-modal {
  min-height: 150px !important;
}
.replicate-modal-content {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 120px;
}
.replicate-modal-message {
  font-size: 14pt;
}
.replicate-modal-buttons {
  text-align: center;
}
</style>
